import { Component, signal, inject } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatButtonModule } from '@angular/material/button';
import { NavSidebarContent } from './nav-sidebar-content/nav-sidebar-content';
import { AppFooter } from './app-footer/app-footer';
import { NeedHelpModal } from './shared/need-help-modal/need-help-modal';
import { NeedHelpService } from './services/need-help.service';
import { filter } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    MatSidenavModule,
    MatButtonModule,
    NavSidebarContent,
    AppFooter,
    NeedHelpModal,
  ],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  needHelp = inject(NeedHelpService);
  private router = inject(Router);

  constructor() {
    // Scroll main content container to the top on every navigation
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntilDestroyed(),
      )
      .subscribe(() => {
        const mainContainer = document.getElementById('main-content-container');
        if (mainContainer) mainContainer.scrollTop = 0;
      });
  }

  isSideNavCollapsed = signal(false);
}
